import { Table } from "antd";
import React from "react";

type Props = { dataSource: any[] };

const AlertErrorTable = ({ dataSource }: Props) => {
  return (
    <Table
      dataSource={dataSource}
      columns={[
        { title: "แถว", dataIndex: "rowindex" },
        {
          title: "รายละเอียด",
          dataIndex: "description",
          render: (text: any) => {
            return (
              <div>
                <ul>
                  {text.map((e: string) => (
                    <li>{e}</li>
                  ))}
                </ul>
              </div>
            );
          },
        },
      ]}
    />
  );
};

export default AlertErrorTable;
